module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-regular.1db1469b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-regular.woff
// module id = 480
// module chunks = 0